.actionBar {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
}

.providerName {
  display: flex;
  gap: 8px;
  align-items: center;
}

.small {
  font-size: 12px;
}

.tiny {
  font-size: 11px;
}

.fullWidth {
  width: 100%;
}

.alignRight {
  text-align: right;
}

.priceRow {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

/* 测试弹窗 */
.testInput {
  margin-top: 16px;
}

.testActions {
  margin-top: 12px;
  text-align: right;
}

.responseBox {
  min-height: 150px;
  max-height: 400px;
  padding: 12px;
  overflow-y: auto;
  background: var(--ant-color-fill-tertiary);
  border-radius: var(--ant-border-radius);
}

.streaming {
  background: var(--ant-color-info-bg);
}

.loadingState {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  padding: 40px;
}

.aiText {
  line-height: 1.6;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

.cursor {
  color: var(--ant-color-primary);
  animation: blink 1s infinite;
}

.responseError {
  margin-top: 12px;
}

.metrics {
  text-align: center;
}

@keyframes blink {
  0%,
  50% {
    opacity: 1;
  }

  51%,
  100% {
    opacity: 0;
  }
}

/* 测试历史 */
.historyCard {
  margin-top: 24px;
}

.historyHeader {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 8px;
}

.historyTime {
  margin-left: auto;
}

.historyContent {
  padding-left: 16px;
}

.historyMetrics {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}

.historyMessage,
.historyError {
  padding: 8px;
  margin-top: 4px;
  font-size: 13px;
  line-height: 1.5;
  border-radius: var(--ant-border-radius-sm);
}

.historyMessage {
  color: var(--ant-color-text-secondary);
  background: var(--ant-color-fill-quaternary);
}

.historyError {
  color: var(--ant-color-error);
  background: var(--ant-color-error-bg);
}
